import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { PipeModule } from "../shared/Pipe/pipe.module";
import { ProfilePhotoThumbnailComponent } from "./components/profile-photo-thumbnail/profile-photo-thumbnail.component";
import { VisitorReadonlyBlockComponent } from "./components/visitor-readonly-block/visitor-readonly-block.component";

@NgModule({
  declarations: [ProfilePhotoThumbnailComponent, VisitorReadonlyBlockComponent],
  imports: [CommonModule, PipeModule],
  exports: [ProfilePhotoThumbnailComponent, VisitorReadonlyBlockComponent],
})
export class DumbModule {}
